import React from 'react';
import { Row, Col, Card } from 'antd';

const RegistroCompleto = ({ correo, nombre = '' }) => {
    return (
        <Row
            justify="center"
            style={{ minHeight: '70vh', paddingTop: '40px' }}
        >
            <Col xs={22} sm={20} md={20}>
                <Card
                    bordered={false}
                    style={{
                        background: '#134472',   // 📌 mismo azul del formulario anterior
                        borderRadius: '20px',    // 📌 igual que la tarjeta previa
                        padding: '40px 35px',
                        boxShadow: '0 8px 22px rgba(0,0,0,0.35)',
                        color: 'white',
                        width: '100%',
                    }}
                >
                    <h2
                        className="textos_titulos_secciones"
                        style={{ marginBottom: 25 }}
                    >
                        ¡Gracias por su registro!
                    </h2>

                    <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                        <span className="texto-breve color_amarillo">
                            <strong>{nombre}</strong>
                        </span>
                        <br /><br />

                        <span className="texto-breve color_blanco">
                            En breve recibirá un correo de confirmación
                            a la siguiente dirección:
                        </span>
                        <br /><br />

                        <span className="correo-azul color_verde">
                            <strong>{correo}</strong>
                        </span>
                        <br /><br />

                        <span className="leyenda color_gris_claro">
                            Si no encuentra el correo de confirmación,
                            revise la carpeta de SPAM / NO DESEADOS.
                        </span>
                    </p>
                </Card>
            </Col>
        </Row>
    );
};

export default RegistroCompleto;
